var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.cellData != null ? 'data-set' : '',_vm.hidden ? 'hidden-cell' : ''],style:({ ..._vm.cellStyle(), ..._vm.cellWidth }),domProps:{"textContent":_vm._s(_vm.cellText())},on:{"click":_vm.openCellDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }